import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class GetScopes {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<string[]> {
    return this.authenticationRepository.getScopes()
  }
}
